import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import {
  useDeleteSystemRole,
  useRoleImpact,
  useSystemRoleDetail,
} from "../hooks/useSystemRoles";
import { useSystemRoleStore } from "../stores/systemRoleStore";

export function DeleteRoleDialog() {
  const targetGuid = useSystemRoleStore((s) => s.deleteTargetGuid);
  const closeDelete = useSystemRoleStore((s) => s.closeDelete);
  const { data: impact, isLoading: impactLoading } = useRoleImpact(targetGuid);
  const { data: role } = useSystemRoleDetail(targetGuid);
  const deleteMutation = useDeleteSystemRole();

  const isOpen = !!targetGuid;

  return (
    <AlertDialog
      open={isOpen}
      onOpenChange={(o) => {
        if (!o) closeDelete();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>시스템 역할 삭제</AlertDialogTitle>
          <AlertDialogDescription>
            {role && (
              <span className="mb-2 block">
                <span className="font-medium text-gray-900">{role.label}</span>
                <span className="ml-1 font-mono text-xs text-gray-500">
                  ({role.code})
                </span>
              </span>
            )}
            {impactLoading ? (
              <span className="text-xs text-gray-500">영향 범위 조회 중...</span>
            ) : impact ? (
              <>
                <span className="block">
                  이 역할은{" "}
                  <strong className="text-gray-900">
                    회사 {impact.companyReplicaCount}개
                  </strong>
                  에서 사용 중이며,{" "}
                  <strong className="text-gray-900">
                    직원 {impact.assignedAccountCount}명
                  </strong>
                  에 영향을 줍니다.
                </span>
                <span className="mt-2 block text-xs">
                  삭제하면 모든 회사 복제본과 부여된 직원 매핑이 즉시 회수됩니다. 정말 삭제하시겠습니까?
                </span>
              </>
            ) : (
              <span className="text-xs text-red-500">
                영향 범위를 불러오지 못했습니다.
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>취소</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            disabled={!targetGuid || deleteMutation.isPending}
            onClick={() => {
              if (!targetGuid) return;
              deleteMutation.mutate({ roleGuid: targetGuid });
            }}
          >
            {deleteMutation.isPending ? "삭제 중..." : "삭제"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
